// Desconto no rodapé do carrinho do Balcão (pedido do dono, 30/09/2026): o
// mesmo "Aplicar desconto ou cupom" do Novo Pedido do Delivery (% ou R$ sobre
// os produtos, ou cupom), pelos componentes de Mesas que espelham o Delivery.
// Estado e contas em hooks/useDescontoBalcao. A classe `dark` deixa os
// componentes do painel no escuro do Balcão.
import DescontoCupom from "../../mesas-fechamento/components/DescontoCupom";
import { itensDoCupom } from "../../novo-pedido-regras/itensDoCupom";

// Enter num campo do desconto aplica (clica o "Aplicar…") e não chega ao
// atalho do Balcão, onde Enter finaliza a venda.
function enterAplica(e) {
  if (e.key !== "Enter" || e.target?.tagName !== "INPUT") return;
  e.preventDefault();
  e.stopPropagation();
  // O último "Aplicar…" é o do formulário aberto; o primeiro é o que abre o painel.
  const aplicar = [...e.currentTarget.querySelectorAll("button")].filter((b) => /^Aplicar/.test(b.textContent.trim()) && !b.disabled).pop();
  aplicar?.click();
}

export default function DescontoCarrinho({ ctx }) {
  const { desconto, cart, cartTotal, cliente } = ctx;
  if (!desconto || !(cartTotal > 0)) return null;
  const { desconto: d, setDesconto, montante } = desconto;
  return (
    <div className="dark" data-e2e="desconto-balcao" onKeyDown={enterAplica}>
      <DescontoCupom
        subtotal={cartTotal}
        desconto={{
          tipo: d.tipo, valor: d.valor, cupom: d.cupom, montante,
          clienteId: cliente?.id || null, clienteTelefone: cliente?.telefone || null,
          // O servidor tira da conta do cupom o item em promoção que não aceita cupom (achado 411).
          itens: itensDoCupom(cart), modulo: "Balcao",
          onAplicar: ({ tipo, valor, cupom }) => setDesconto({ tipo, valor: valor || 0, cupom: cupom || null }),
          onRemover: () => desconto.limparDesconto(),
        }}
      />
    </div>
  );
}
